export default __webpack_public_path__ + "static/media/1st-final.ca97b552.gif";